module.exports = __webpack_public_path__ + "img/logo3mix-1.fe66cbd7.jpg";